import React from "react";
import Banner from "component/banner/Banner";
import Header from "component/header/Header";
import Services from "component/services/Services";
import styles from "./Home.module.css";

import Support from "component/support/Support";
import FaqContent from "component/Modules/faq/FaqContent";
import { Container } from "@mui/system";
import Privacy from "component/privacy/Privacy"
function Home() {
  return (
    <div className={styles.home}>
      <Header />
      <Banner />
      <Services />
      <Container>
        <div id="faqs">
          <FaqContent type={""} />
        </div>
      </Container>
      <div style={{ marginTop: 50, paddingBottom: 60 }}>
        <Support />
      </div>

      <Privacy/>
    </div>
  );
}

export default Home;
